import React, { useEffect, useState } from 'react'
import { GenericFormSpreadTypeComponent } from '../../../../genericComponents/forms/GenericFormSpreadTypeComponent'
import Icons from '../../../../assets/icons';
import statesJson from '../../../../constants/states.json'
import { dispatchHandler } from '../../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';

const AddNewAddress = (props) => {

    const {selectedData = {}} = props;
    console.log("permission obj",props.permissionObj);

    const dispatch = useDispatch();

    let allStates = statesJson?.["states"];

    const [inputState, setInputState] = useState(Object.keys(selectedData || {})?.length > 0 ? {
        "basicDetails" : {
            "addressLine1" : selectedData?.["address"] || null,
            "addressLine2" : selectedData?.["addressLine1"] || null,
            "shortName" : selectedData?.["shortName"] || null, 
            "email" : selectedData?.["email"] || null,
            "zipCode" : selectedData?.["zipCode"] || null,
            "contactPerson": selectedData?.["contactPerson"] || null,
            "contactNumber" : selectedData?.["contactNumber"] || null,
            "id" : selectedData?.["id"] || null,
            "country" : selectedData?.country ? {
                "country" : selectedData?.country || "",
            } : null,
            "state" : selectedData?.state ? {
                "state" : selectedData?.state || "",
            } : null,
            "city" : selectedData?.city ? {
                "city" : selectedData?.city || "",
            } : null,
        }
    } : {
        "country" : {"country" : "India"}
    });

    console.log("Input state", inputState);
    const [errorData, setErrorData] = useState({});

    const getInputProps = (key) => {

        let labelObj = {
            "country" : "Country",
            "state" : "State",
            "city" : "City"
        }

        let obj = {
            headerKeys : {
                [key] : {value : labelObj?.[key] },
            },
            itemKeys : {
                [key] : [key],
            },
        }

        switch(key){
            case "country" :{
                return{
                    ...obj,
                    getListData : () => ([{"country" : "India"}])
                }
            }
            case "state":{
                return{
                    ...obj,
                    search:{
                        placeholder: "Search...",
                        isSearchIconRequire: true,
                        customSearchFunction: (listState, listFunctions) => {
                            const { listData, currentSearch } = listState;
                            console.log('listState, listData', listState, listData)
                            return listData?.filter(item => item?.state?.toLowerCase().includes(currentSearch?.toLowerCase()));
                        },
                    },
                    getListData:() => Object.keys(allStates || {})?.map(val => ({[key] : val})),
                }
            }
            case "city":{
                return{
                    ...obj,
                    search:{
                        placeholder: "Search...",
                        isSearchIconRequire: true,
                        customSearchFunction: (listState, listFunctions) => {
                            const { listData, currentSearch } = listState;
                            return listData?.filter(item => item?.city?.toLowerCase().includes(currentSearch?.toLowerCase()));
                        }
                    },
                    modalMainClass: '!left-auto !right-[12px]',
                    getListData:() => allStates?.[inputState?.["basicDetails"]?.["state"]?.["state"] || {}]?.map(val => ({[key] : val})),
                }
            }
        }
    }

    console.log('selectedData1121', selectedData)

    return (
        <GenericFormSpreadTypeComponent
            className="add-new-address"
            headerComponent={{
                label: {
                    contentPrimary: Object.keys(selectedData || {})?.length ? "Edit Address" : "Add New Address",
                },
                closeModal: props.closeModal
            }} 

            inputSections={{
                "basicDetails": {
                    inputFields: () => ([
                        { key: "shortName", label: "Short Name", type: "text", mandatory: true },
                        {key : "email", label : "Email", type : "email", mandatory : true},
                        {key : "addressLine1", label : "Address  Line1", mandatory : true, type : "textarea", genInputExtraClass: "textarea-w-scroll"},
                        {key : "addressLine2", label : "Address Line2", type: "textarea", genInputExtraClass: "textarea-w-scroll"},
                        {key : "country", label : "Country", mandatory : true, type : "dropdown", iconRight :<Icons.DownArrowNew/>,  inputProps: () => getInputProps("country")},
                        {key : "state", label : "State", mandatory : true, type : "dropdown", onChange: (val, state) => {
                            if(inputState?.["basicDetails"]?.["state"]?.["state"] != val?.["state"]){
                                delete state?.["city"];
                            }
                            return state;
                        } ,iconRight :<Icons.DownArrowNew/>,  inputProps: () => getInputProps("state")},
                        {key : "city", label : "City", mandatory : true, type : "dropdown", isDisabled: () => !inputState?.["basicDetails"]?.["state"], iconRight :<Icons.DownArrowNew/>,  inputProps: () => getInputProps("city")},
                        {key : "zipCode", label : "Zip Code", mandatory:true, type : "pincode"},
                        {key : "contactPerson", label : "Contact Person", mandatory : true, type : "text"},
                        {key : "contactNumber", label : "Contact Number", mandatory : true, type : "mobileNo"}
                    ])
                }
            }}

            finalSubmit={(data) => {
                let {basicDetails = {}} = data;
                dispatchHandler(dispatch, "updateAddressRequest", {
                    "shortName": basicDetails?.["shortName"] || "",
                    "address": basicDetails?.["addressLine1"] || "",
                    "addressLine1": basicDetails?.["addressLine2"] || "",
                    "city": basicDetails?.["city"]?.["city"] || "",
                    "state": basicDetails?.["state"]?.["state"] || "",
                    "country": basicDetails?.["country"]?.["country"] || "",
                    "zipCode": basicDetails?.["zipCode"] || "",
                    "contactPerson": basicDetails?.["contactPerson"] || "",
                    "contactNumber": basicDetails?.["contactNumber"] || "",
                    "email": basicDetails?.["email"] || "",
                    "id" : selectedData?.id || undefined,
                    "apiUrl" : selectedData?.id ? "/address/master/update"  : "/address/master/create",
                }, props.permissionObj)
            }}

            inputState={inputState}
            updateInputState={setInputState}
            errorState = {{...errorData}}
            updateErrorState = {setErrorData}

            finalSubmitButton = {selectedData?.id ? "Update" : "Submit"}

            closeModal={props.closeModal}
            clearDataButtonNotRequired={true}
        />
    )
}

export default AddNewAddress